import { useMemo, type ComponentProps } from 'react';

import { TextSection } from '../TextSection';

interface HeadMessageProps {
  message:
    | {
        size?: ComponentProps<typeof TextSection>['size'];
        text: ComponentProps<typeof TextSection>['children'];
      }
    | string;
}

export const HeadMessage = ({ message }: HeadMessageProps) => {
  const { size, text } = useMemo(
    () => (typeof message === 'string' ? { text: message } : message),
    [message],
  );

  return <TextSection size={size}>{text}</TextSection>;
};
